import React from "react"

export function QuantityInput({ textColor }) {
  return (
    <>
      <label
        className="formkit-pwyw-input___label"
        htmlFor="quantityInput"
        style={{ color: textColor }}
      >
        Quantity
      </label>
      <div className="flex-row w-full relative">
        <input
          id="quantityInput"
          className="formkit-input formkit-pwyw-input"
          name="quantity"
          required={true}
          type="number"
          min="1"
          placeholder={1}
        />
      </div>
    </>
  )
}
